<template>
  <el-form
    :model="form"
    ref="form"
    :rules="rules"
    class="settings"
    label-width="80px"
  >
    <el-form-item label="方案" prop="scheme" v-if="schemeOptions.length > 1">
      <el-select
        v-model="form.scheme"
        @change="schemeChange"
        placeholder="请选择方案"
      >
        <el-option
          class="selectStyle"
          v-for="item in schemeOptions"
          :label="item.name"
          :value="item.guid"
          :key="item.guid"
        ></el-option>
      </el-select>
    </el-form-item>
    <!-- v-if="designLineOptions.length > 1" -->
    <el-form-item
      label="设计线"
      prop="designLine"
      v-if="designLineOptions.length > 1"
    >
      <el-select
        v-model="form.designLine"
        @change="designLineChange"
        placeholder="请选择设计线"
      >
        <el-option
          class="selectStyle"
          v-for="item in designLineOptions"
          :label="item.name"
          :value="item.guid"
          :key="item.guid"
        ></el-option>
      </el-select>
    </el-form-item>
  </el-form>
</template>
<script>
import { getPlansService, getLineByPlanService } from "@/api/api";

export default {
  name: "schemeDesignLine",
  props: [],
  data() {
    return {
      form: {
        designLine: null,
        scheme: null,
      },
      rules: {
        designLine: [
          { required: true, message: "请选择设计线", trigger: "blur" },
        ],
        scheme: [{ required: true, message: "请选择方案", trigger: "blur" }],
      },
      schemeOptions: [],
      designLineOptions: [],
    };
  },
  created() {
    this.getPlansMethod();
  },
  methods: {
    // 获取方案下拉框数据
    getPlansMethod() {
      getPlansService({
        // projectGuid: "64d1f27b-e58a-11ed-915e-00505688b0dd",
        projectGuid: window.sessionStorage.getItem("roadProjectId"),
      }).then((res) => {
        this.schemeOptions = res.data.data;
        this.$nextTick(() => {
          if (this.schemeOptions.length > 0) {
            this.form.scheme = this.schemeOptions[0].guid;
            this.$emit("getPlanGuid", this.form.scheme);
            this.getDesignLinesMethod(this.form.scheme);
          }
        });
      });
    },
    // 获取设计线下拉框数据
    getDesignLinesMethod(data) {
      getLineByPlanService({
        planGuid: data,
        loadVirtualLine: true,
      }).then((res) => {
        this.form.designLine = null;
        this.$emit("getDesignLineGuid", null);
        this.designLineOptions = res.data.data;
        this.$nextTick(() => {
          if (this.designLineOptions.length > 0) {
            this.form.designLine = this.designLineOptions[0].guid;
            this.$emit("getDesignLineGuid", this.form.designLine);
          }
        });
      });
    },
    // 方案下拉框选中
    schemeChange(data) {
      this.$emit("getPlanGuid", data);
      this.getDesignLinesMethod(data);
    },
    // 设计线下拉框选中
    designLineChange(data) {
      this.$emit("getDesignLineGuid", data);
    },
    // 校验
    requiredCheck(formName) {
      let isCheck = null;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          isCheck = true;
        } else {
          isCheck = false;
        }
      });
      return isCheck;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/index.scss";
@import "@/assets/scss/box.scss";
.el-form.settings {
  width: 100%;
  padding: 8px 36px 17px 0;
  /deep/ .el-radio-group {
    margin-top: 7px !important;
  }
  /deep/ .el-form-item {
    width: 100%;
    padding: 0 0 0 18px;
    margin: 20px 0px;
    margin-top: 0;
    .el-form-item__label {
      min-height: 1px;
      margin-bottom: 0px;
      font-size: 12px;
      @include font_color("t_color_op1");
      padding-right: 10px;
      line-height: 32px;
    }
    .el-form-item__content {
      margin-left: 0px !important;
      font-size: 12px;
      display: flex;
      align-items: center;
      flex-grow: 1;
      line-height: 32px;
      min-height: 32px;
      .el-select {
        @include select_base();
      }
      .el-input {
        @include input_base();
      }
      .el-textarea {
        @include textarea_base();
      }
      .el-checkbox {
        @include checkbox_base();
      }
    }
    .el-input__inner {
      width: 100% !important;
    }
    .el-input-group__prepend {
      border-color: rgba(245, 245, 245, 0.6) !important;
      color: rgba(255, 255, 255, 0.9) !important;
      background: none;
      padding: 0 10px;
    }
    &.btns {
      padding: 6px 0 0 89px;
      .el-form-item__content {
        width: auto;
        .el-button--primary {
          @include lheight(28);
          @include font_color("t_color_op1");
          @include background_color("t_color1_op2");
          @include border_color("t_color1_op2");
          padding: 0 15px;
          margin: 6px 16px 0 0;
          span {
            @include lheight(28);
            font-size: 12px;
            display: block;
            text-align: center;
          }
          &:hover {
            @include background_color("t_color1_op1");
            @include border_color("t_color1_op1");
          }
          &.is-disabled {
            // @include font_color("t_color_sc1");
            // @include background_color("t_color1_op3");
            @include border_color("t_color1_op3");
            background-color: rgba(42, 183, 255, 0.4) !important;
            color: rgba(255, 255, 255, 0.9) !important;
            &:hover {
              background-color: rgba(42, 183, 255, 0.4) !important;
            }
            span {
              background: none;
              // @include font_color("t_color_sc1");
            }
          }
        }
        .el-button--default {
          @include lheight(28);
          @include font_color("t_color_op2");
          @include background_color("t_color3_op2");
          @include border_color("t_color_op2");
          padding: 0 15px;
          margin: 6px 16px 0 6px;
          span {
            @include lheight(24);
            font-size: 12px;
            display: block;
            text-align: center;
          }
          &:hover {
            @include background_color("t_color3_op1");
            @include border_color("t_color_op1");
            @include font_color("t_color_op1");
          }
        }
      }
    }
    &:first-child {
      padding: 10px 0 0 18px;
    }
  }
  .main .el-form-item.btns {
    // padding: 0;
    // margin: 0;
    .el-form-item__content .el-button--primary {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 12px 20px;
    }
  }
  .rich {
    /deep/ .el-form-item__label {
      float: none;
    }
    /deep/ .el-form-item__content {
      width: 100% !important;
      margin: 0 !important;
    }
  }
}
.flexRight {
  display: flex;
  padding: 20px 0px;
  margin-right: -16px;
  align-items: center !important;
  width: 100%;
  justify-content: flex-end;
}
</style>
